import React, { useEffect, useRef, useState } from "react";
import { ProductIntroContainer } from "./styled";

import SmProducts from "../../shopping/component/themes/simple/smProducts";
import { NavButton } from "../../shopping/component/styled/simpleTheme";
import { useNavigate, useOutletContext } from "react-router";
import Info from "./productIntro/info";
import Products from "./productIntro/products";
import { findTargetMenuName } from "../../common/function/shopping";
import axios from "axios";

const smCategories = [
  {
    name: "키오스크",
    label: "키오스크",
    description: "매장 내 비대면 주문\n및 결제 시스템",
  },
  {
    name: "POS",
    label: "포스",
    description: "매장 판매, 결제\n재고 관리를 위한 시스템",
  },
  {
    name: "신용카드 단말기",
    label: "신용카드단말기",
    description: "신용카드 및 모바일\n결제 전용 단말기",
  },
  {
    name: "부가서비스",
    label: "부가서비스",
    description: "포인트 적립, 멤버십 등\n매장 추가 서비스",
  },
];

const ProductIntro = () => {
  const { menus, url, cmpnyNo } = useOutletContext();
  const navigate = useNavigate();
  const [active, setActive] = useState(0);
  const [product, setProduct] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (cmpnyNo) {
      getPrductList();
    }
  }, [cmpnyNo]);

  const getCategory = async (products) => {
    const url = "/api/categories";
    const res = await axios.post(url, {});

    if (res.status === 200) {
      const data = res?.data || [];
      const filtered = data
        .filter((item) => products.some((ele) => item.categoryId === ele.categoryId))
        .map((item) => ({
          ...item,
          description:
            smCategories.find((ele) => ele.name === item.categoryName)?.description || "",
        }));

      setCategories(filtered);

      if (filtered.length > 0) {
        setActive(filtered[0]);
      }
    }
  };

  const getPrductList = async () => {
    try {
      const url = "/erp/vendorProducts/get";
      const query = `
        query VendorProducts(
          $cmpnyNo: Int!
        ) {
          vendorProducts(
            filter: {
              cmpnyNo: $cmpnyNo
            }
          ) {
            totalCount
            products {
              id
              name
              brand
              categoryId
              media
              price
            }
          }
        }
      `;

      const variables = { cmpnyNo: parseInt(cmpnyNo, 10) };
      const body = { query, variables };
      const res = await axios.post(url, body);

      if (res.status === 200) {
        setProduct(res.data.products);
      }

      getCategory(res.data.products);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ProductIntroContainer>
      <h3>
        <span>{findTargetMenuName(menus, 1)}</span>
      </h3>
      <>
        <div className="section">
          <Info categories={categories} active={active} setActive={setActive} />
          <Products categories={categories} active={active} product={product} />
        </div>
      </>
      <SmProducts products={product} />
      <NavButton>
        <button
          onClick={() =>
            navigate(`/shop/${url}/shoppingNotice?page=0`, { state: { tabIndex: 1 } })
          }>
          문의하기
        </button>
      </NavButton>
    </ProductIntroContainer>
  );
};

export default ProductIntro;
